export default class SolicitationDTO {
  constructor(solicitation) {
    this.id = solicitation.id;
    this.operator = solicitation.operator;
    this.requester = solicitation.requester;
    this.sector = solicitation.sector.id;
    this.description = solicitation.description;
    this.priority = solicitation.priority;
    this.diagnose = solicitation.diagnose;
    this.status = solicitation.status;
    this.date = solicitation.date;
    this.avaliable = solicitation.avaliable;
    this.url = solicitation.url;
  }
}